/**
 * Captures invite/recovery hash tokens from the URL BEFORE Supabase's
 * createClient() consumes and clears them. This module MUST be imported
 * before supabase.ts creates the client.
 *
 * Supabase's createClient() calls detectSessionInUrl synchronously at
 * construction time, clearing window.location.hash via History.replaceState().
 * By the time any React useEffect runs, the tokens are gone.
 */

const hash = window.location.hash;

if (hash && hash.includes('access_token')) {
  const params = new URLSearchParams(hash.slice(1));
  const type = params.get('type');

  if (type === 'invite' || type === 'recovery' || type === 'magiclink') {
    sessionStorage.setItem(
      '__supabase_auth_type',
      JSON.stringify({
        type,
        access_token: params.get('access_token'),
        refresh_token: params.get('refresh_token'),
      })
    );
  }
}

export function getStoredAuthType(): {
  type: string;
  access_token: string;
  refresh_token: string;
} | null {
  const raw = sessionStorage.getItem('__supabase_auth_type');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearStoredAuthType() {
  sessionStorage.removeItem('__supabase_auth_type');
}
